import { MenuItem, MenuList, Paper } from '@mui/material';

import { PLAN_BAY_OPTIONS, TP_OPTIONS_SUBMENU_IDS } from '../constants';
import { TP_OPTIONS_SUBMENU_PAPER_SX, TP_OPTIONS_SUBMENU_ROW_SX } from '../styles';
import { hasPlanId } from '../utils';
import InProgressPlanNotice from './InProgressPlanNotice';
import SelectPlanSubmenuRow from './SelectPlanSubmenuRow';

import type { ReactNode } from 'react';
import type { TpOptionsSubmenuProps } from './types';

export default function TpOptionsSubmenu({
  submenu,
  treatmentPlan,
  treatmentPlans,
  activeTreatmentPlan,
  tpStatusIdByLabel,
  inProgressTpId,
  onBayPick,
  onPlanPick,
  onKeyDown,
}: TpOptionsSubmenuProps) {
  let content: ReactNode;
  if (submenu.id === TP_OPTIONS_SUBMENU_IDS.SELECT_PLAN) {
    content = treatmentPlans
      .filter(hasPlanId)
      .map((plan) => (
        <SelectPlanSubmenuRow
          key={plan.id}
          treatmentPlan={plan}
          isActive={plan.id === activeTreatmentPlan?.id}
          isCurrent={plan.id === treatmentPlan?.id}
          tpStatusIdByLabel={tpStatusIdByLabel}
          onSelect={onPlanPick}
        />
      ));
  } else if (inProgressTpId !== null) {
    content = <InProgressPlanNotice inProgressTpId={inProgressTpId} onPlanClick={onPlanPick} />;
  } else {
    content = PLAN_BAY_OPTIONS.map((option) => (
      <MenuItem
        key={option.label}
        data-testid={option.testId}
        sx={TP_OPTIONS_SUBMENU_ROW_SX}
        onClick={() => onBayPick(option.bay)}
      >
        {option.label}
      </MenuItem>
    ));
  }

  // The paper is a child of the menu paper, so its top follows the anchor row's offset.
  return (
    <Paper sx={TP_OPTIONS_SUBMENU_PAPER_SX} style={{ top: submenu.anchorEl.offsetTop }}>
      <MenuList
        autoFocusItem={submenu.focusOnOpen}
        variant="menu"
        disablePadding
        onKeyDown={onKeyDown}
      >
        {content}
      </MenuList>
    </Paper>
  );
}
